module.exports = __webpack_public_path__ + "img/04.c077c4ac.jpg";